import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { Image, TextInput } from '../../types'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'
import { MediaQueries } from '../../../enums/media-queries'
import { ImageSize } from '../../../enums/image-size'
import { ModalSize } from '../../../enums/modal-size'
import { MbModalService } from '../../../../shared/services/modal.service'
import { BehaviorSubject, combineLatest } from 'rxjs'
import { map } from 'rxjs/operators'

@Component({
  selector: 'mb-image-modal',
  templateUrl: './image-modal.component.html',
  styleUrls: ['./image-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ImageModalComponent {

  @Input() set image (image: Image | undefined) {
    this.image$.next(image)
  }

  @Input() caption: TextInput | undefined
  @Input() description: TextInput | undefined
  @Input() id: string | undefined
  @Input() size: ModalSize | undefined

  image$ = new BehaviorSubject<Image | undefined>(undefined)

  modalImage$ = this.image$.pipe(
    map(image => this.modalService.getModalImageFromImage(image ?? {} as Image, this.size ?? ModalSize.LG)))

  state$ = combineLatest([this.image$, this.modalImage$]).pipe(map(([image, modalImage]) => ({ image, modalImage } as ImageModalState)))

  constructor (private modal: NgbActiveModal,
               private modalService: MbModalService) {
  }

  close () {
    this.modal.close()
  }

  readonly mediaQuery = MediaQueries
  readonly imageSize = ImageSize
}

export interface ImageModalState {
  image: Image | undefined;
  modalImage: Image | undefined;
}
